<template>
  <div id="page-product" class="page">
    <div class="thumbnail" v-for="(product, index) in productData" :key="`icon-product-${index}`">
      <img :src="`/static/icon-${product.model}.png`" />
      <p>{{product.model}}</p>
    </div>
    <ul class="products">
      <li v-for="(product, index) in productData" :key="`product-${index}`">
        <img class="avatar" :src="`/static/${product.model}.png`" />
        <div class="product-info">
          <header>
            <p class="left">型号</p>
            <p class="right">{{product.model}}</p>
          </header>
          <div class="item bg-light-gray">
            <p class="left">外形尺寸（宽*深*高mm）</p>
            <p class="right">W{{product.outerWidth}}*D{{product.outerDepth}}*H{{product.outerHeight}}</p>
          </div>
          <div class="item">
            <p class="left">内箱尺寸（宽*深*高mm）</p>
            <p class="right">W{{product.innerWidth}}*D{{product.innerDepth}}*H{{product.innerHeight}}</p>
          </div>
          <div class="item bg-light-gray">
            <p class="left">有效容积</p>
            <p class="right">{{product.volume}}</p>
          </div>
          <div class="item">
            <p class="left">储藏温度（℃）</p>
            <p class="right">{{product.minTemperature}}℃-{{product.maxTemperature}}℃</p>
          </div>
          <div class="item bg-light-gray">
            <p class="left">制冷</p>
            <p class="right">{{product.coldMethod | coldMethod}}</p>
          </div>
          <div class="item">
            <p class="left">耗电量（kWh/24h）</p>
            <p class="right">{{product.power}}</p>
          </div>
          <div class="item bg-light-gray">
            <p class="left">可识别方式</p>
            <p class="right">{{product.recognition | recognition}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import productData from '../data/product.json'
export default {
  name: 'product',
  data () {
    return {
      productData
    }
  },
  mounted () {
    console.log(productData)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#page-product {
  .thumbnail {
    display: inline-block;
    margin: 20px 40px;
    font-size: 12px;
  }
  .products {
    list-style: none;
    padding-left: 0;
    width: 1000px;
    margin: 20px auto;
  }
  .products li {
    position: relative;
    clear: both;
    margin: 40px;
  }

  .products li

  .avatar {
    position: absolute;
    top: 50%;
    left: 100px;
    transform: translate(-50%, -50%);
    height: 261px;
  }
  .product-info{
    margin-left: 300px;
    text-align: left;

    header {
      font-size: 14px!important;
      color: #333333;
      font-weight: 400;
      padding: 5px;
    }

    .item {
      position: relative;
      clear: both;
      font-size: 12px;
      color: #484848;
      font-weight: 200;
      margin: 10px 0;
      padding: 5px;
      p {
        margin: 0;
        font-size: 14px!important;
      }
    }
    .item:after {
      content: '';
      display: block;
      clear: both;
    }

    .item.bg-light-gray {
      background-color: #f8f8f8;
    }

    .left {
      font-size: 14px;
      padding: 0 20px;
      box-sizing: border-box;
      float: left;
      width: 50%;
    }

    .right {
      padding: 0 20px;
      box-sizing: border-box;
      float: left;
      width: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Product.vue